import { categories } from "./categories";

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  tags: string[];
  imageUrl: string;
  publishDate: string;
  author: string;
  views: number;
  isHot: boolean;
  isTop: boolean;
}

export const articles: Article[] = [
  {
    id: "article-001",
    title: "独家：某顶流男星深夜私会神秘女子，酒店共度8小时细节曝光",
    excerpt: "据知情人士透露，该男星近期正在拍摄一部大制作电影，却频繁在深夜与一名非圈内女子密会，两人在某五星级酒店多次被目击同进同出。",
    content: `<p>娱乐圈再掀波澜！据多位知情人士向黑料王独家爆料，某当下炙手可热的顶流男星近期频繁在深夜与一名神秘女子约会，两人的亲密举动已被多次目击。</p>
<p>据悉，该男星因主演一部古装仙侠剧而爆红，目前人气正值巅峰，微博粉丝已突破五千万。然而表面光鲜亮丽的他，私下生活却颇为复杂。</p>
<p>据酒店工作人员透露，该男星与这名女子在过去一个月内至少在该酒店出现过四次，每次都是深夜十一点后登记入住，次日清晨七点左右分别离开。两人在电梯间的亲密举动也被酒店监控拍下。</p>
<p>更令人震惊的是，有知情人士爆料，这名神秘女子并非圈内人，而是一位在某金融公司工作的白领。两人疑似通过共同朋友介绍认识，至今已秘密交往超过半年。</p>
<p>该男星的经纪团队目前尚未对此事作出回应。粉丝们对此反应两极：一部分粉丝表示"艺人也有私生活，请尊重"，另一部分则对其刻意隐瞒恋情的做法表示失望。</p>
<p>黑料王将持续跟踪报道此事进展，敬请关注后续独家爆料。</p>`,
    category: "lianqing-baoguang",
    tags: ["顶流男星", "秘密恋情", "酒店私会", "深夜密会"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20blurred%20silhouettes%20of%20two%20people%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20watermark%2C%20warm%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20mysterious%20and%20intriguing%20vibe&width=800&height=500&seq=article-001&orientation=landscape",
    publishDate: "2026-08-06",
    author: "黑料王编辑部",
    views: 1285000,
    isHot: true,
    isTop: true,
  },
  {
    id: "article-002",
    title: "某女星片场耍大牌惹众怒，助理当场被骂哭，导演愤然离场",
    excerpt: "多位剧组工作人员联名爆料，该女星在拍摄期间态度极其恶劣，不仅迟到早退，还多次无故辱骂工作人员，导致片场气氛紧张。",
    content: `<p>片场从来都不是太平之地，但这次的爆料依旧让人瞠目结舌。据多位不愿透露姓名的剧组工作人员向黑料王爆料，某当红女星在最新剧组的拍摄过程中，多次展现出令人无法忍受的"大牌"作风。</p>
    <p>据现场工作人员描述，该女星在进组第一天就迟到了整整三个小时，全组人员干等不说，她到场后还嫌化妆间太小、休息椅不够舒服，当场要求更换。制片人无奈只得临时协调，导致当天拍摄计划全部打乱。</p>
    <p>更过分的是，在一次拍摄中，因为一个简单的走位问题，该女星当着全组人员的面将一名女性助理骂得狗血淋头。据目击者称，助理当场被骂哭，而该女星却面不改色地继续指责对方"不专业"。导演在多次劝说无果后，愤然摔剧本离场，当天的拍摄也因此中断。</p>
    <p>该女星此前在公开场合一直以"亲和力强""没架子"的形象示人，此次爆料与其公众形象形成巨大反差。不少网友翻出她之前的采访视频，发现多处言行不一的地方。</p>
    <p>目前该剧组的拍摄进度已受到明显影响，投资方也开始介入调查。如果事态持续恶化，不排除更换女主角的可能性。</p>`,
    category: "pianchang-baoliao",
    tags: ["耍大牌", "片场冲突", "女星丑闻", "剧组内幕"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20tense%20film%20set%20atmosphere%20with%20empty%20director%20chair%20and%20scattered%20scripts%20on%20the%20ground%2C%20dramatic%20spotlight%20casting%20harsh%20shadows%2C%20behind%20the%20scenes%20chaos%2C%20cinematic%20moody%20lighting%2C%20no%20text%2C%20dark%20atmosphere%2C%20professional%20film%20set%20equipment%20abandoned&width=800&height=500&seq=article-002&orientation=landscape",
    publishDate: "2026-08-05",
    author: "片场观察员",
    views: 986000,
    isHot: true,
    isTop: true,
  },
  {
    id: "article-003",
    title: "深扒某综艺节目黑幕：淘汰名单早有内定，选手遭恶意剪辑",
    excerpt: "某热门选秀综艺被曝存在严重黑幕，节目组通过恶意剪辑引导舆论，淘汰名单在录制前就已确定，选手们的命运早已被资本操控。",
    content: `<p>选秀节目的"真实性"一直饱受质疑，而黑料王获得的最新内幕消息，更是让这一质疑得到了有力印证。</p>
    <p>据一位参与过该综艺后期制作的工作人员透露，节目组在进行剪辑时有一套完整的"造星"和"毁人"流程。所谓的"黑马选手"其实早在海选阶段就被制作方相中，后续的镜头分配、剧情线设计都是围绕这些"天选之子"展开的。</p>
    <p>更令人心寒的是恶意剪辑的问题。该工作人员爆料，有一位颇具实力的选手因为在后台与某赞助商代表发生口角，随后在正片中被刻意剪辑成"人品差""不合群"的形象，弹幕和评论区一片谩骂。而实际上，该选手私下与其他选手关系融洽，所谓的"冲突"完全是断章取义。</p>
    <p>淘汰名单方面的问题同样触目惊心。据透露，每一轮的淘汰名单在正式录制前就已经通过内部会议确定，所谓的"现场投票""观众选择"不过是走过场。某些选手的商业价值被资本方评估后，就能获得"保送"资格，无论实际表现如何。</p>
    <p>目前该综艺的豆瓣评分已从开播时的8.2分跌至5.7分，越来越多的观众开始意识到节目存在的问题。但制作方至今未对此做出任何回应。</p>`,
    category: "zongyi-neimu",
    tags: ["综艺黑幕", "恶意剪辑", "选秀节目", "内定淘汰"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dark%20backstage%20view%20of%20a%20talent%20show%20studio%20with%20empty%20seats%20and%20dim%20stage%20lights%2C%20spotlight%20on%20an%20empty%20microphone%20stand%2C%20eerie%20atmosphere%2C%20behind%20the%20scenes%20corruption%20theme%2C%20no%20text%2C%20cinematic%20photography&width=800&height=500&seq=article-003&orientation=landscape",
    publishDate: "2026-08-04",
    author: "综艺调查员",
    views: 756000,
    isHot: true,
    isTop: false,
  },
  {
    id: "article-004",
    title: "某知名演员涉嫌税务问题被约谈，工作室紧急注销引猜测",
    excerpt: "据可靠消息，该演员名下多家工作室在近一个月内密集注销，同时被税务部门约谈的消息也不胫而走，疑似重蹈某范姓艺人覆辙。",
    content: `<p>税务问题再次成为娱乐圈的焦点话题。黑料王从多个渠道获悉，某位在国内拥有极高知名度的演员近日因涉嫌税务问题被相关部门约谈。</p>
    <p>值得关注的是，该演员名下关联的多家工作室在近一个月内出现了密集注销的情况。根据企业信息查询平台的数据显示，这些工作室的注销时间高度集中，且注销原因均为"决议解散"，这一异常举动引发了外界的广泛猜测。</p>
    <p>业内人士分析认为，工作室集中注销通常是为了应对即将到来的调查或审计，这种做法在之前的某范姓艺人事件中也有出现。如果该演员确实存在税务问题，根据相关法律法规，可能面临巨额罚款甚至是刑事处罚。</p>
    <p>目前该演员的社交媒体账号仍在正常更新，但其最新一条动态的评论区已被大量关于税务问题的留言淹没。粉丝们纷纷表示担忧，希望偶像能够平安渡过此劫。</p>
    <p>该演员的经纪团队对此事保持沉默，未对任何媒体的采访请求做出回应。黑料王将持续关注事件的最新进展。</p>`,
    category: "mingxing-heiliao",
    tags: ["税务问题", "工作室注销", "约谈调查", "明星黑料"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20image%20of%20scattered%20financial%20documents%20and%20stamps%20on%20a%20dark%20office%20desk%2C%20moody%20lighting%20with%20deep%20shadows%2C%20business%20closure%20theme%2C%20no%20text%2C%20no%20visible%20faces%2C%20cinematic%20noir%20style%2C%20suspenseful%20atmosphere&width=800&height=500&seq=article-004&orientation=landscape",
    publishDate: "2026-08-03",
    author: "黑料王调查组",
    views: 1560000,
    isHot: true,
    isTop: false,
  },
  {
    id: "article-005",
    title: "独家实锤：某女团成员与已婚富豪约会照片流出",
    excerpt: "一组偷拍照片近日在圈内疯传，照片中某当红女团成员与一位已婚富豪在某私人会所举止亲密，两人关系非同一般。",
    content: `<p>女团偶像的光环下，到底隐藏着多少不为人知的秘密？黑料王近日获得一组令人震惊的偷拍照片，照片中的女主角正是某当红女团的C位成员。</p>
    <p>据提供照片的线人透露，这组照片拍摄于上个月的一个周末晚上。照片显示，该女团成员与一位中年男子在某高档私人会所的包厢内举止亲密，两人不仅紧挨而坐，还多次出现搂抱、耳语等暧昧动作。</p>
    <p>经过深入调查，这名男子被确认为某知名地产集团的副总裁，已婚并育有两个孩子。其妻子是圈内小有名气的模特，两人结婚已有八年。</p>
    <p>更令人惊讶的是，据会所工作人员回忆，两人并非第一次在该场所见面。在过去半年内，他们至少在这里见过三次面，每次都是选择最私密的VIP包厢，并且行动十分谨慎。</p>
    <p>该女团所属经纪公司对于此事暂未发表评论。但在照片流出后，该成员的社交媒体账号已由公开转为仅好友可见，多个品牌代言也被紧急撤下。</p>`,
    category: "chouwen-jiemi",
    tags: ["女团成员", "已婚富豪", "约会照片", "丑闻实锤"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20luxurious%20private%20club%20interior%20with%20dim%20ambient%20lighting%2C%20empty%20velvet%20sofa%2C%20champagne%20glasses%20on%20table%2C%20secretive%20and%20exclusive%20atmosphere%2C%20no%20people%20visible%2C%20no%20text%2C%20moody%20and%20mysterious%20vibe%2C%20cinematic%20photography&width=800&height=500&seq=article-005&orientation=landscape",
    publishDate: "2026-08-02",
    author: "黑料王独家",
    views: 2100000,
    isHot: true,
    isTop: true,
  },
  {
    id: "article-006",
    title: "某实力派演员私下竟是赌场常客，一夜输掉千万面不改色",
    excerpt: "该演员在荧幕上塑造了无数正面形象，然而私下却沉迷赌博。据澳门某赌场内部人士爆料，其每次光顾都是VIP待遇，出手阔绰。",
    content: `<p>银幕上的正人君子，赌场里的豪掷千金。这样巨大的反差，出现在了一位以"德艺双馨"著称的实力派演员身上。</p>
    <p>据澳门某知名赌场的内部员工向黑料王透露，该演员是赌场的常客，几乎每个月都会光顾一到两次。赌场为其安排了专属VIP接待团队，每次到来都是专车接送、豪华套房安排，享受最高级别的贵宾待遇。</p>
    <p>该员工回忆，有一次他亲眼看到该演员在百家乐赌桌上，一夜间输掉了将近一千万元，但其表情淡定，仿佛输掉的只是一笔零花钱。该员工感叹："那种气度，一看就是经常来的人。"</p>
    <p>赌博在澳门虽然合法，但对于一位公众人物而言，沉迷赌博的行为无疑会对其形象造成负面影响。尤其是该演员曾在多个公开场合大谈"健康生活""远离不良嗜好"，言行不一的表里不一更加令人失望。</p>
    <p>有网友翻出该演员近几年的作品产量明显下降的细节，猜测这可能与其赌博行为有关。长期沉迷于赌博场所，势必会影响其正常的演艺工作。</p>`,
    category: "siren-shenghuo",
    tags: ["明星赌博", "澳门赌场", "千万赌资", "表里不一"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20luxurious%20casino%20interior%20with%20poker%20chips%20scattered%20on%20green%20felt%20table%2C%20golden%20ambient%20lighting%2C%20empty%20chair%2C%20opulent%20and%20excessive%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20dramatic%20cinematic%20photography%2C%20dark%20moody%20vibe&width=800&height=500&seq=article-006&orientation=landscape",
    publishDate: "2026-08-01",
    author: "赌场观察员",
    views: 892000,
    isHot: false,
    isTop: false,
  },
  {
    id: "article-007",
    title: "某导演被曝利用选角之便潜规则新人，多名女演员勇敢发声",
    excerpt: "随着#MeToo运动的持续发酵，又有重量级爆料浮出水面。某资深导演被多名新人女演员指控，在选角过程中存在严重的不当行为。",
    content: `<p>娱乐圈的潜规则从来都不是新闻，但每一次被曝光出来，依然让人愤怒不已。这一次，矛头指向了一位在国内颇具影响力的资深导演。</p>
    <p>发起指控的是三位已经退出演艺圈的前女演员。她们在接受黑料王专访时，详细描述了自己在参加该导演新片选角时的遭遇。据她们描述，该导演会以"单独试戏"为由，将新人演员叫到酒店房间或私人工作室，随后提出超出正常试戏范畴的"特殊要求"。</p>
    <p>其中一位化名小A的前演员含泪回忆道："他说这是行业规矩，想红就得付出代价。我当时刚毕业，什么都不懂，就信了他的话。"小A表示，那次经历给她造成了严重的心理创伤，也是她最终选择退出演艺圈的主要原因。</p>
    <p>另外两位前演员的经历也大同小异。她们在拒绝导演的要求后，原本已经谈好的角色立刻被换成了别人。三人后来互相联系后才发现，自己并非个例。</p>
    <p>该导演目前正在筹备一部投资过亿的大制作电影，此爆料无疑将对该项目造成重大影响。多家投资方表示正在密切关注事态进展，不排除撤资的可能性。</p>`,
    category: "pianchang-baoliao",
    tags: ["潜规则", "导演丑闻", "选角黑幕", "女演员发声"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dark%20and%20empty%20audition%20room%20with%20a%20single%20spotlight%20on%20an%20empty%20chair%2C%20cold%20atmosphere%2C%20dramatic%20shadows%2C%20film%20camera%20in%20background%2C%20no%20people%2C%20no%20text%2C%20cinematic%20photography%2C%20tense%20and%20uncomfortable%20mood&width=800&height=500&seq=article-007&orientation=landscape",
    publishDate: "2026-07-31",
    author: "黑料王调查组",
    views: 678000,
    isHot: false,
    isTop: false,
  },
  {
    id: "article-008",
    title: "某流量小生私生活混乱被实锤，同时交往三名女友聊天记录曝光",
    excerpt: "一位自称是该流量小生前女友的网友在社交媒体上发布大量聊天记录截图，揭露了其同时在至少三段感情中周旋的真相。",
    content: `<p>流量小生的"清新单纯"人设在一夜之间崩塌。一位微博用户在凌晨时分发布了一篇长文，配上大量聊天记录截图，详细揭露了某流量小生的"海王"行径。</p>
    <p>发布爆料的用户自称是该小生的前女友之一，两人交往时间长达一年半。据她描述，她最初并不知道对方同时还有其他女友，直到一次偶然的机会，她发现男友手机中有多个不同女生发来的暧昧消息。</p>
    <p>经过深入调查，她发现该小生同时在和至少三名女生交往，时间线高度重叠。三个女生分别位于北京、上海和成都，而该小生利用出差的机会，在不同城市间周旋，时间管理堪称"大师级"。</p>
    <p>聊天记录截图显示，该小生对三个女生说的话高度雷同，甚至连甜言蜜语都是复制粘贴。更令人啼笑皆非的是，他还会在与A约会时，给B发消息说"在拍戏，好想你"。</p>
    <p>爆料发布后，该小生的粉丝群体出现了严重分裂。一部分忠实粉丝坚决不相信，称聊天记录是"恶意P图"；另一部分则表示"太失望了，脱粉"。该小生及其团队目前尚未对此事作出任何回应。</p>`,
    category: "lianqing-baoguang",
    tags: ["流量小生", "多角恋", "聊天记录", "人设崩塌"],
    imageUrl: "https://readdy.ai/api/search-image?query=Multiple%20smartphones%20lying%20on%20a%20dark%20surface%20showing%20message%20bubbles%2C%20dramatic%20red%20and%20dark%20lighting%2C%20betrayal%20and%20deception%20theme%2C%20no%20visible%20text%20content%2C%20no%20people%2C%20cinematic%20photography%2C%20tense%20moody%20atmosphere&width=800&height=500&seq=article-008&orientation=landscape",
    publishDate: "2026-07-30",
    author: "情感调查员",
    views: 1890000,
    isHot: true,
    isTop: false,
  },
  {
    id: "article-009",
    title: "某综艺嘉宾酒后真言引爆全网：节目组安排剧本强制造话题",
    excerpt: "一段在私人饭局上偷录的音频近日在网络疯传，某综艺常驻嘉宾在醉酒后大谈节目组的各种操作，信息量巨大令人咋舌。",
    content: `<p>酒后的真言往往最要命。一段时长约15分钟的偷录音频最近在各大社交平台疯传，音频中的主角是某热门综艺的常驻嘉宾，其在醉酒状态下透露了大量节目内幕。</p>
    <p>根据音频内容，该嘉宾承认节目中的很多"冲突"和"感动瞬间"都是节目组事先安排好的剧本。他举例说，某一期节目中两个嘉宾之间的"即兴争吵"，实际上是节目组提前一周就写好的剧本，两人还排练了多次才呈现出"真实"的效果。</p>
    <p>更令人震惊的是，该嘉宾还透露节目组会刻意制造"人设"。某些嘉宾在节目中表现出的性格特征，与其真实性格几乎完全相反。一个在节目中看起来"憨厚老实"的嘉宾，私下其实非常精明世故；而一个被塑造成"毒舌"形象的嘉宾，私下性格反而非常温和。</p>
    <p>音频中还提到了赞助商的干预问题。据该嘉宾透露，节目组在制定每期内容时，都会优先考虑赞助商的利益诉求。某些产品的植入方式虽然看起来"生硬"，但节目组宁愿牺牲节目质量，也不愿得罪金主。</p>
    <p>该音频爆出后，节目组迅速发布声明否认了一切指控，称该音频"系恶意剪辑拼接，已委托律师处理"。但网友们显然不买账，纷纷表示"酒后吐真言，这次我信了"。</p>`,
    category: "zongyi-neimu",
    tags: ["综艺剧本", "酒后真言", "人设造假", "赞助商干预"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20blurry%20restaurant%20private%20room%20scene%20with%20empty%20wine%20glasses%20and%20bottles%20on%20table%2C%20warm%20dim%20lighting%2C%20secretive%20atmosphere%2C%20eavesdropping%20theme%2C%20no%20people%2C%20no%20text%2C%20cinematic%20photography%2C%20mysterious%20mood&width=800&height=500&seq=article-009&orientation=landscape",
    publishDate: "2026-07-29",
    author: "音频调查员",
    views: 1350000,
    isHot: true,
    isTop: false,
  },
  {
    id: "article-010",
    title: "深扒某女星豪门梦碎内幕：婆家嫌弃艺人身份，婚后被要求退圈",
    excerpt: "该女星去年风光嫁入豪门，婚后却频繁传出与婆家不和的消息。黑料王独家获悉，其婆婆一直看不起她的艺人身份，婚后对她百般刁难。",
    content: `<p>嫁给豪门，是多少女星的终极梦想。但豪门生活真的如想象中那般美好吗？一位去年刚刚嫁入豪门的女星用自己的亲身经历给出了否定的答案。</p>
    <p>据与该女星关系密切的闺蜜透露，婚后的生活与该女星婚前想象的完全不同。最大的问题是来自婆婆的压力。这位婆婆出身名门，一直看不起娱乐圈出身的人，当初之所以同意这门亲事，完全是因为儿子以断绝母子关系相威胁。</p>
    <p>婆婆在婚后对该女星展开了全面的"改造计划"。首先被要求辞去所有演艺工作，彻底退出娱乐圈。其次要求她学习茶道、插花、书法等"名媛必修课"，以适应上流社会的社交需求。该女星原本是一个活泼开朗的人，在这样的环境中逐渐变得沉默寡言。</p>
    <p>更过分的是，婆婆还在各种家庭聚会上当众贬低她，称她"除了那张脸什么都不会"。丈夫虽然偶尔会为她说话，但在母亲面前始终不敢太过强硬。据闺蜜透露，该女星已经多次萌生了离婚的念头，但考虑到舆论影响以及婚前协议中关于离婚赔偿的条款，一直犹豫不决。</p>
    <p>目前该女星的社交媒体更新频率明显下降，最近一条动态停留在两个月前。她的粉丝们纷纷留言表达关心，希望她能够勇敢做出对自己最好的选择。</p>`,
    category: "siren-shenghuo",
    tags: ["豪门", "婆媳矛盾", "婚后生活", "女星困境"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20grand%20but%20cold%20luxury%20mansion%20interior%20with%20empty%20ornate%20furniture%2C%20lonely%20atmosphere%2C%20golden%20cage%20metaphor%2C%20dim%20natural%20light%20through%20large%20windows%2C%20no%20people%2C%20no%20text%2C%20cinematic%20photography%2C%20melancholy%20mood&width=800&height=500&seq=article-010&orientation=landscape",
    publishDate: "2026-07-28",
    author: "豪门观察员",
    views: 723000,
    isHot: false,
    isTop: false,
  },
  {
    id: "article-011",
    title: "某选秀冠军疑整容过度面部僵硬，与参赛时期判若两人",
    excerpt: "近日该选秀冠军在出席某商业活动时的现场照片引发热议，网友纷纷指出其面部表情僵硬、五官比例失调，疑似经历了多次整容手术。",
    content: `<p>选秀时期的青涩少女，如今变成了面部僵硬的"人造美女"。这样的变化发生在一位曾经的选秀节目冠军身上，让人唏嘘不已。</p>
    <p>该艺人近日出席某品牌商业活动时，现场高清照片被网友大量转发。照片中，她的面部表情明显僵硬，笑起来的时候嘴角弧度不太自然，鼻子也比之前高耸了许多，整体五官比例与选秀时期相去甚远。</p>
    <p>整形外科医生在看过照片后分析认为，该艺人至少经历过隆鼻、开眼角、面部脂肪填充、下巴假体等多项手术，而且可能是短期内集中操作的，导致面部各部位之间的协调性出现了问题。</p>
    <p>该艺人的粉丝对此表现出了两极化的反应。一部分粉丝坚持认为这是"妆容和光线的问题"，另一部分则表示"只要她自己开心就好"。但也有不少路人网友表示惋惜，认为她原本就很好看，"何必把自己整成这样"。</p>
    <p>从行业角度来看，娱乐圈对女艺人外貌的高要求是导致整容泛滥的重要原因。但过度整容带来的不仅是外貌上的不自然，更可能对身体健康造成不可逆的伤害。</p>`,
    category: "mingxing-heiliao",
    tags: ["整容", "选秀冠军", "面部僵硬", "容貌焦虑"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20before%20and%20after%20contrast%20concept%2C%20mirror%20reflection%20showing%20different%20appearance%2C%20beauty%20and%20vanity%20theme%2C%20dark%20glamorous%20lighting%2C%20no%20faces%20clearly%20visible%2C%20no%20text%2C%20cinematic%20photography%2C%20thought-provoking%20mood&width=800&height=500&seq=article-011&orientation=landscape",
    publishDate: "2026-07-27",
    author: "颜值观察员",
    views: 567000,
    isHot: false,
    isTop: false,
  },
  {
    id: "article-012",
    title: "揭秘某经纪公司压榨艺人黑幕：一九分成的血泪合同曝光",
    excerpt: "一份号称'奴隶合同'的经纪合约被曝光，签约艺人只能拿到一成收入，还要承担各种不合理费用，甚至有艺人倒贴钱工作。",
    content: `<p>在光鲜亮丽的娱乐圈背后，是无数被经纪公司压榨的艺人。黑料王近日获得了一份堪称"奴隶合同"的经纪合约，其中的条款令业内人士都感到震惊。</p>
    <p>这份合约的核心问题是收入分配。根据合同条款，艺人所有演艺收入的分配比例为"公司九成、艺人一成"。更过分的是，这一成还包含了各种税费和经纪人提成，艺人实际到手的收入可能不到总收入的5%。</p>
    <p>合同还规定，艺人在合约期间产生的一切费用——包括服装造型费、交通费、住宿费、培训费等，全部由艺人自己承担。有签约艺人透露，自己在某些工作结束后算账，发现不仅没赚到钱，反而还要倒贴。</p>
    <p>解约条款更是令人绝望。如果艺人想要提前解约，需要支付高达千万级别的违约金。很多签约艺人实际上是"被困"在合约中，想走也走不了。一位前签约艺人在接受采访时说："那几年就像坐牢一样，每天都在盼着合约到期的那一天。"</p>
    <p>该经纪公司在业内颇有名气，旗下有多位一线艺人。如果这份合同属实，意味着这些光鲜的明星们可能也在承受着不公平的待遇。目前该公司未对这份合同的真实性做出任何回应。</p>`,
    category: "chouwen-jiemi",
    tags: ["经纪公司", "奴隶合同", "收入压榨", "行业黑幕"],
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dark%20office%20scene%20with%20a%20contract%20document%20under%20dramatic%20spotlight%2C%20pen%20and%20ink%2C%20exploitation%20and%20unfairness%20theme%2C%20heavy%20shadows%2C%20no%20visible%20text%20content%2C%20no%20people%2C%20cinematic%20photography%2C%20oppressive%20mood&width=800&height=500&seq=article-012&orientation=landscape",
    publishDate: "2026-07-26",
    author: "合约调查员",
    views: 445000,
    isHot: false,
    isTop: false,
  },
];